// <pfs-collapsible-group>: koordiniert mehrere <pfs-collapsible> (PFS-729).
//   data-mode="multiple" (default) → jedes toggelt unabhängig.
//   data-mode="single"             → Accordion: Öffnen eines schließt die anderen.
//
// Reiner Koordinator: lauscht auf die (bubbling+composed) pfs:collapsible-toggle-
// Events seiner Kinder und schließt im single-Modus die Geschwister. Setzt
// data-open direkt (das emittiert KEIN Event → keine Schleife). Ein durch-
// reichender <slot> hält die Kinder im Light-Flow (eigene Shadows/Styling).
//
// Nutzung: Terminlisten (multiple), Stepper-Zeilen (single), FAQ (single).

import { defineComponent } from "../../composition/define-component.js";
import { withShadow } from "../../composition/with-shadow.js";

const STYLES = `:host { display: block; }`;

defineComponent({
  tagName: "pfs-collapsible-group",
  mixins: [withShadow()],
  render(host, ctx) {
    const root = ctx.shadowRoot;
    if (!root) return;
    const style = document.createElement("style");
    style.textContent = STYLES;
    const slot = document.createElement("slot");
    root.append(style, slot);

    // Nur die DIREKT zu DIESER Gruppe gehörenden Collapsibles (nicht die einer
    // verschachtelten Untergruppe).
    const ownItems = (): Element[] =>
      Array.from(host.querySelectorAll("pfs-collapsible")).filter(
        (c) => c.closest("pfs-collapsible-group") === host,
      );

    const onToggle = (e: Event): void => {
      if ((host.dataset.mode ?? "multiple") !== "single") return;
      const detail = (e as CustomEvent<{ open: boolean }>).detail;
      if (!detail?.open) return; // nur beim ÖFFNEN die anderen schließen
      const opened = e.target as Element;
      for (const item of ownItems()) {
        if (item !== opened && item.hasAttribute("data-open")) item.removeAttribute("data-open");
      }
    };
    host.addEventListener("pfs:collapsible-toggle", onToggle);
    ctx.cleanup.push(() => host.removeEventListener("pfs:collapsible-toggle", onToggle));
  },
});
